import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Send } from 'lucide-react';
export function CTA() {
  return <section className="py-32 bg-white relative overflow-hidden" data-id="element-69">
      <div className="container mx-auto px-6 md:px-12" data-id="element-70">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-71">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full h-[400px] md:h-[500px] bg-surface rounded-[2.5rem] overflow-hidden relative shadow-xl border border-line group" data-id="element-72">
            <div className="absolute inset-0 bg-black/5 pointer-events-none z-10 group-hover:bg-transparent transition-colors duration-500" data-id="element-73"></div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d81312.51381666872!2d30.4426227284752!3d50.44095101037562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4ce50f8b6e3c3%3A0xb528dc4d6bfc05cb!2sKyiv%2C%20Ukraine%2C%2002000!5e0!3m2!1sen!2sus!4v1715000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0,
            filter: 'grayscale(100%) contrast(1.2) opacity(0.9)'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Maps Kyiv" className="transition-all duration-700 group-hover:filter-none" data-id="element-74"></iframe>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-75">
            <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-6" data-id="element-76">
              Готові до змін?
            </h2>
            <div className="w-12 h-1 bg-ink rounded-full mb-8" data-id="element-77"></div>
            <p className="text-muted font-normal text-lg mb-12 leading-relaxed" data-id="element-78">
              Запишіться на сеанс або зв'яжіться зі мною зручним для вас
              способом для безкоштовної консультації. Я завжди на зв'язку!
            </p>

            <div className="space-y-6" data-id="element-79">
              <a href="tel:+380971214358" className="flex items-center text-lg text-ink hover:text-muted transition-colors group" data-id="element-80">
                <div className="w-14 h-14 bg-surface border border-line rounded-full flex items-center justify-center mr-6 group-hover:bg-ink group-hover:border-ink transition-all duration-300 shadow-sm" data-id="element-81">
                  <Phone className="text-ink group-hover:text-white transition-colors" size={20} strokeWidth={1.5} data-id="element-82" />
                </div>
                <span className="font-medium tracking-tight" data-id="element-83">
                  +38 097 121 43 58
                </span>
              </a>

              <a href="#viber" className="flex items-center text-lg text-ink hover:text-muted transition-colors group" data-id="element-84">
                <div className="w-14 h-14 bg-surface border border-line rounded-full flex items-center justify-center mr-6 group-hover:bg-ink group-hover:border-ink transition-all duration-300 shadow-sm" data-id="element-85">
                  <MessageCircle className="text-ink group-hover:text-white transition-colors" size={20} strokeWidth={1.5} data-id="element-86" />
                </div>
                <span className="font-medium tracking-tight" data-id="element-87">Viber</span>
              </a>

              <a href="#telegram" className="flex items-center text-lg text-ink hover:text-muted transition-colors group" data-id="element-88">
                <div className="w-14 h-14 bg-surface border border-line rounded-full flex items-center justify-center mr-6 group-hover:bg-ink group-hover:border-ink transition-all duration-300 shadow-sm" data-id="element-89">
                  <Send className="text-ink group-hover:text-white transition-colors" size={20} strokeWidth={1.5} data-id="element-90" />
                </div>
                <span className="font-medium tracking-tight" data-id="element-91">Telegram</span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}